import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Layout, Table, Row, Col, Button, Icon, Input } from 'antd'

import UpdateRightParamSet from '@components/Popup/UpdateRightParamSet'
import RightsPopup from '@components/Popup/RightsPopup'
import ParametersPopup from '@components/Popup/ParametersPopup'
import RightParamSetPolicies from '@components/Popup/RightParamSetPolicies'

import * as style from './style.scss'

@inject((store: any) => {
    const { popupStore, rightParamSetStore, rightsStore, parametersStore, policiesStore } = store
    return { popupStore, rightParamSetStore, rightsStore, parametersStore, policiesStore }
})
@observer
class RightParamSets extends Component<any, any> {
    handleToggleRights = async right_param_set => {
        const { popupStore, rightsStore } = this.props
        await rightsStore.getRightsList({ right_param_set_id: right_param_set.id })
        rightsStore.resetFilters()
        popupStore.togglePopup('editRights', { ...right_param_set })
    }
    handleToggleParameters = right_param_set => {
        const { popupStore, parametersStore } = this.props
        parametersStore.getParametersList({ right_param_set_id: right_param_set.id })
        popupStore.togglePopup('editParameters', { ...right_param_set })
    }
    handleTogglePoliciesList = right_param_set => {
        const { popupStore, policiesStore } = this.props
        policiesStore.setFilters('right_param_set_id', right_param_set.id)
        policiesStore.getPaginationList()
        popupStore.togglePopup('policiesList', {
            title: `שיוך פוליסות לטבלה - ${right_param_set.name} (מזהה ${right_param_set.id})`,
            right_param_set_id: right_param_set.id
        })
    }
    render() {
        const { popupStore, rightParamSetStore } = this.props
        const { filteredList, filterText, filterList } = rightParamSetStore
        const columns = [
            {
                title: 'מזהה',
                key: 'id',
                width: 50,
                align: 'center',
                render: (_, record) => <span>{record.id}</span>
            },
            {
                title: '',
                key: 'edit',
                width: 50,
                align: 'right',
                render: (_, record) => (
                    <Button onClick={() => popupStore.togglePopup('rightParamSet', { ...record })}>
                        <Icon type="edit" />
                    </Button>
                )
            },
            {
                title: 'שם הטבלה',
                key: 'name',
                align: 'right',
                render: (_, record) => <span>{record.name}</span>
            },
            {
                title: 'כיסויים',
                key: 'rights',
                width: 250,
                align: 'right',
                render: (_, record) => (
                    <Button onClick={() => this.handleToggleRights({ ...record })}>
                        הצג כיסויים ({record.__meta__.related_rights ? record.__meta__.related_rights : '--'})
                    </Button>
                )
            },
            {
                title: 'פרמטרים',
                key: 'parameters',
                width: 250,
                align: 'right',
                render: (_, record) => (
                    <Button onClick={() => this.handleToggleParameters({ ...record })}>
                        הצג פרמטרים ({record.__meta__.related_parameters ? record.__meta__.related_parameters : '--'})
                    </Button>
                )
            },
            {
                title: 'פוליסות מקושרות',
                key: 'policies',
                width: 250,
                align: 'right',
                render: (_, record) => (
                    <Button onClick={() => this.handleTogglePoliciesList({ ...record })}>
                        קישור פוליסות ({record.__meta__.related_policies ? record.__meta__.related_policies : '--'})
                    </Button>
                )
            },
            {
                title: 'עודכן ע"י',
                key: 'updated_by',
                width: 200,
                render: (_, record) => <span>{record.updated_by}</span>
            },
            {
                title: 'עדכון אחרון',
                width: 200,
                key: 'updated_at',
                render: (_, record) => <span>{record.updated_at}</span>
            }
        ]
        return (
            <Layout style={{ padding: '1rem', backgroundColor: 'white' }}>
                <Row>
                    <Col xs={4}>
                        <Button style={{ width: '98%' }} onClick={() => popupStore.togglePopup('rightParamSet')}>
                            <Icon type="plus" /> הוסף טבלה
                        </Button>
                    </Col>
                    <Col xs={20}>
                        <Input.Search
                            placeholder="חיפוש טבלה על פי שם"
                            onChange={e => filterList(e.target.value)}
                            value={filterText}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="box">
                            <Table
                                className="center-table"
                                style={{ width: '100%' }}
                                rowKey="id"
                                columns={columns}
                                rowClassName={() => style.user_row}
                                dataSource={filteredList}
                                pagination={{
                                    pageSize: 10
                                }}
                            />
                        </div>
                    </Col>
                </Row>
                <RightParamSetPolicies />
                <ParametersPopup />
                <UpdateRightParamSet />
                <RightsPopup />
            </Layout>
        )
    }
}

export default RightParamSets
